import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { TourBookingService } from '@univacity/angular/datas';
import { TourBooking } from '@univacity/shared/types';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TourBookingResolver implements Resolve<Observable<TourBooking>> {
  constructor(private svc: TourBookingService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<TourBooking> {
    const observable = route.params['id']
      ? this.svc.findOne(route.params['id'], {
          ...route.queryParams,
          increaseView: true,
          populate: ['tour'],
        })
      : this.svc.findByReference(
          route.queryParams['reference'],
          route.queryParams['lastName'],
          {
            ...route.queryParams,
            increaseView: true,
            populate: ['tour.name', 'tour.theme', 'tour.coverPhoto'],
          }
        );
    return observable;
  }
}
